var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectiumLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 691 370.1",
    style: {
      enableBackground: "new 0 0 691 370.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{clip-path:url(#SVGID_4_);}\r\n\t.st3{clip-path:url(#SVGID_6_);}\r\n\t.st4{clip-path:url(#SVGID_8_);}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st6{fill:url(#SVGID_9_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st7{fill:url(#SVGID_10_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st8{fill:url(#SVGID_11_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st9{fill:url(#SVGID_12_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st10{fill:#FDFDFD;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1048.7758,
    y1: 1679.1866,
    x2: 1036.1741,
    y2: 1776.6389,
    gradientTransform: "matrix(-0.5725 -0.8199 0.8199 -0.5725 -645.4993 2072.4568)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)",
      stroke: "#2C8FFF",
      strokeWidth: 1.3407,
      strokeMiterlimit: 10
    },
    d: "M139.2,236.2 c0,0,12.2,28.1,47.3,10.8c31.1-15.4,19.5-56,15.8-53.5c0,0-3.3,11.7-17,15.9c-13.6,4.1-38.3,4.5-45.2,13.4 C140.2,222.8,135.6,227.7,139.2,236.2z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.5,201.6h-34.8c0.3,4.3,2,7.8,5,10.5c3,2.7,6.8,4,11.4,4c2.6,0,5-0.5,7.1-1.4c2.2-0.9,4-2.3,5.6-4.1 l3.2,3.6c-1.8,2.2-4.1,3.9-6.9,5.1c-2.8,1.2-5.8,1.7-9.1,1.7c-4.3,0-8-0.9-11.3-2.7c-3.3-1.8-5.9-4.3-7.7-7.5 c-1.8-3.2-2.8-6.8-2.8-10.9c0-4.1,0.9-7.7,2.6-10.9c1.8-3.2,4.2-5.7,7.3-7.5c3.1-1.8,6.5-2.7,10.4-2.7c3.8,0,7.3,0.9,10.4,2.7 c3.1,1.8,5.5,4.3,7.2,7.5c1.7,3.2,2.6,6.8,2.6,10.9L263.5,201.6z M233.4,187.4c-2.7,2.6-4.3,5.9-4.6,10h29.5 c-0.4-4.1-1.9-7.4-4.6-10c-2.7-2.6-6.1-3.8-10.2-3.8C239.4,183.5,236.1,184.8,233.4,187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275,162h5.6v58.6H275V162z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.5,201.6h-34.8c0.3,4.3,2,7.8,5,10.5c3,2.7,6.8,4,11.4,4c2.6,0,5-0.5,7.1-1.4c2.2-0.9,4-2.3,5.6-4.1 l3.2,3.6c-1.8,2.2-4.1,3.9-6.9,5.1c-2.8,1.2-5.8,1.7-9.1,1.7c-4.3,0-8-0.9-11.3-2.7c-3.3-1.8-5.9-4.3-7.7-7.5 c-1.8-3.2-2.8-6.8-2.8-10.9c0-4.1,0.9-7.7,2.6-10.9c1.8-3.2,4.2-5.7,7.3-7.5c3.1-1.8,6.5-2.7,10.4-2.7c3.8,0,7.3,0.9,10.4,2.7 c3.1,1.8,5.5,4.3,7.2,7.5c1.7,3.2,2.6,6.8,2.6,10.9L332.5,201.6z M302.3,187.4c-2.7,2.6-4.3,5.9-4.6,10h29.5 c-0.4-4.1-1.9-7.4-4.6-10c-2.7-2.6-6.1-3.8-10.2-3.8C308.4,183.5,305.1,184.8,302.3,187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.2,218.3c-3.2-1.8-5.8-4.3-7.6-7.5c-1.8-3.2-2.8-6.9-2.8-10.9c0-4.1,0.9-7.7,2.8-10.9 c1.8-3.2,4.4-5.7,7.6-7.5c3.2-1.8,6.9-2.7,11-2.7c3.6,0,6.8,0.7,9.6,2.1c2.8,1.4,5,3.4,6.7,6.1l-4.2,2.8 c-1.4-2.1-3.1-3.6-5.2-4.6c-2.1-1-4.4-1.5-6.9-1.5c-3,0-5.7,0.7-8.1,2c-2.4,1.3-4.3,3.3-5.6,5.7c-1.3,2.5-2,5.3-2,8.5 c0,3.2,0.7,6,2,8.5c1.3,2.4,3.2,4.3,5.6,5.7c2.4,1.3,5.1,2,8.1,2c2.5,0,4.8-0.5,6.9-1.5c2.1-1,3.8-2.5,5.2-4.6l4.2,2.8 c-1.6,2.7-3.9,4.7-6.7,6.1c-2.8,1.4-6,2.1-9.6,2.1C357.2,221,353.5,220.1,350.2,218.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421,168.8c-0.8-0.8-1.2-1.7-1.2-2.8c0-1.1,0.4-2,1.2-2.8c0.8-0.8,1.8-1.2,2.9-1.2c1.2,0,2.1,0.4,2.9,1.1 c0.8,0.8,1.2,1.7,1.2,2.7c0,1.2-0.4,2.1-1.2,2.9c-0.8,0.8-1.8,1.2-2.9,1.2C422.8,170,421.8,169.6,421,168.8z M421.1,179h5.6v41.6 h-5.6V179z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.1,211.2c-1.1,3.8-3.6,5.1-6,6.9c-3.2,2.5-9.4,2.9-12.7,2.9c-5.4,0-9.7-1.5-12.8-4.5 c-3.1-3-4.7-7.5-4.7-13.3V179h5.6v23.5c0,4.4,1.1,7.7,3.2,10c2.2,2.3,5.2,3.4,9.2,3.4c4.4,0,7.8-1.3,10.3-4 c2.5-2.7,3.8-6.4,3.8-11.1V179h5.6C479.6,209.1,478.1,211.2,478.1,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M559.6,183.2c3,3,4.5,7.4,4.5,13.3v24.1h-5.6v-23.5c0-4.3-1-7.6-3.1-9.9c-2.1-2.3-5-3.4-8.8-3.4 c-4.3,0-7.7,1.3-10.2,4c-2.5,2.7-3.7,6.3-3.7,11v21.8H527v-23.5c0-4.3-1-7.6-3.1-9.9c-2.1-2.3-5-3.4-8.9-3.4 c-4.3,0-7.7,1.3-10.2,4c-2.5,2.7-3.8,6.3-3.8,11v21.8h-5.6v-23l0.6-5.4l1.2-3.3l1.9-3.1c1.8-2.5,5.3-3.7,7.9-5.1 c2.6-1.4,5.7-2.1,9.1-2.1c3.5,0,6.5,0.7,9,2.2c2.6,1.5,4.5,3.7,5.7,6.6c1.5-2.7,3.7-4.9,6.6-6.4c2.9-1.6,6.1-2.3,9.8-2.3 C552.6,178.7,556.7,180.2,559.6,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.8,187.7v-4.4h-21.4v-12.8h-5.3v36.7c0,0-0.1,13.8,14.9,13.8c0,0,14.6,0.3,14.1-15.4h-5.2 c0,0,1.3,10.3-9.3,10.3c0,0-8.9,0.7-9.2-8.2c0-0.1,0-0.3,0-0.4c0-9.3,0-19.5,0-19.5L412.8,187.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1210.2437,
    y1: 1184.4756,
    x2: 1197.642,
    y2: 1281.9276,
    gradientTransform: "matrix(-9.590000e-02 -0.9954 0.9954 -9.590000e-02 -950.7181 1526.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)",
      stroke: "#2C8FFF",
      strokeWidth: 1.3407,
      strokeMiterlimit: 10
    },
    d: "M126.9,199.7 c0,0-3.2,30.5,35.9,32.6c34.7,1.9,44.5-39.3,40.1-38.8c0,0-8.7,8.6-22.6,5.5c-13.9-3.1-35.6-14.9-46-10.5 C134.3,188.5,127.9,190.4,126.9,199.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 888.5853,
    y1: 384.7436,
    x2: 875.9837,
    y2: 482.195,
    gradientTransform: "matrix(0.7071 -0.7071 0.7071 0.7071 -768.9184 490.556)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)",
      stroke: "#2C8FFF",
      strokeWidth: 1.3407,
      strokeMiterlimit: 10
    },
    d: "M147.7,139.9 c0,0-25.6,17-2.3,48.5c20.6,28,58.6,9.4,55.5,6.2c0,0-12.1-1.2-18.6-13.9c-6.5-12.7-11.1-36.9-21.2-42.2 C161.1,138.5,155.5,134.8,147.7,139.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.1948,
    y1: 102.3186,
    x2: 184.5932,
    y2: 199.7697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)",
      stroke: "#2C8FFF",
      strokeWidth: 1.3407,
      strokeMiterlimit: 10
    },
    d: "M204.7,117.8 c0,0-30.1-6.1-35.9,32.6c-5.2,34.3,34.8,48,34.8,43.6c0,0-7.7-9.5-3.3-23c4.4-13.5,18.3-34,14.9-44.8 C215.1,126.2,213.8,119.7,204.7,117.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectiumLogo);
export default __webpack_public_path__ + "static/media/electiumLogo.c95959f3a29083688652c0b07b317f62.svg";
export { ForwardRef as ReactComponent };